
import BatchDispersionStateView from './BatchDispersionStateView'

import useBatchDispersionState from '../../hooks/useBatchDispersionState'

import './BatchDispersionState.css'
import type { PayoutDataType } from '../../../../../../typings/types'

interface IBatchDispersionStateProps {
    timeZoneCode: string
    // uploadFileIdSelected: string
    selectedPayouts: Record<string, PayoutDataType>
    fetchedPayouts: Record<string, PayoutDataType>
    isFetchingPayout: boolean
    reloadBatchDispersionState: () => void
    setIsFetchingPayout: React.Dispatch<React.SetStateAction<boolean>>
    setAreLoadingPayoutsList: React.Dispatch<React.SetStateAction<boolean>>
    // newPayoutId: string
    // currentPayout: PayoutDataType
    // setCurrentPayout: any
    // setIsDispersionStateLoading: any
    // handleDispersionLoadingDone: (option: boolean) => void
};

const BatchDispersionState = ({
  timeZoneCode,
  // uploadFileIdSelected = '',
  selectedPayouts,
  fetchedPayouts,
  isFetchingPayout,
  setIsFetchingPayout,
  setAreLoadingPayoutsList,
  reloadBatchDispersionState
  // newPayoutId,
  // currentPayout,
  // setCurrentPayout,
  // setIsDispersionStateLoading,
  // handleDispersionLoadingDone
}: IBatchDispersionStateProps) => {
  const {
    fileNameSelected,
    // payoutDataSelected,
    bankSelected,
    processStatus,
    transactionReportsOptions,
    transactionReportsRef,
    isLoading,
    isProcess,
    isOpenTransactionReports,
    statusHistoryTimelineOpened,
    canViewStatusHistory,
    handleClickSelectBank,
    handleClickSelectExport,
    handleClickTransactionReport,
    handleClickTransactionReportsBanks,
    handleClickStatusHistoryTrigger
  } = useBatchDispersionState({
    timeZoneCode,
    // currentPayout,
    // setCurrentPayout,
    setIsDispersionStateLoading: () => {},
    setAreLoadingPayoutsList,
    setIsFetchingPayout,
    // selectedPayouts,
    fetchedPayouts,
    reloadBatchDispersionState
    // handleDispersionLoadingDone
  })

  /*
     * Renderizado del componente del Estado de Dispersión del archivo subido Batch
    */
  return (
    <BatchDispersionStateView
      timeZoneCode={timeZoneCode}
      fileNameSelected={fileNameSelected}
      // payoutDataSelected={payoutDataSelected}
      bankSelected={bankSelected}
      // currentPayout={currentPayout}
      selectedPayouts={selectedPayouts}
      processStatus={processStatus}
      transactionReportsOptions={transactionReportsOptions}
      transactionReportsRef={transactionReportsRef}
      isLoading={isLoading}
      isProcess={isProcess}
      isOpenTransactionReports={isOpenTransactionReports}
      statusHistoryTimelineOpened={statusHistoryTimelineOpened}
      fetchedPayouts={fetchedPayouts}
      isFetchingPayout={isFetchingPayout}
      canViewStatusHistory={canViewStatusHistory}
      handleClickSelectExport={handleClickSelectExport} // eslint-disable-line
      handleClickSelectBank={handleClickSelectBank}
      handleClickTransactionReport={handleClickTransactionReport}
      handleClickTransactionReportsBanks={handleClickTransactionReportsBanks}
      handleClickStatusHistoryTrigger={handleClickStatusHistoryTrigger}
    />
  )
}

export default BatchDispersionState
